import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { sessionStorageKeys, tqMutationKeys } from "lib/constants";
import { EvendyApi } from "lib/utils/api-utils";

interface RequestPayoutResponse {
  message: string;
  statusCode: number;
  success?: boolean;
  data?: unknown;
}

interface RequestPayoutPayload {
  eventId: number;
}

type UseRequestPayoutResult = UseMutationResult<RequestPayoutResponse, Error, RequestPayoutPayload>;

export function useRequestPayout(): UseRequestPayoutResult {
  return useMutation({
    mutationFn: async ({ eventId }: RequestPayoutPayload) => {
      try {
        // Retrieve the Base64-encoded credentials from session storage
        const encodedCredentials = sessionStorage.getItem(sessionStorageKeys.accessToken);

        if (!encodedCredentials) {
          throw new Error("Authentication credentials not found.");
        }

        const res = await EvendyApi.post<RequestPayoutResponse>(
          `/requests/organizer/request-payout/${eventId}`,
          {}, // Explicit empty body
          {
            headers: {
              "x-api-key": encodedCredentials,
              "Content-Type": "application/json",
            },
          },
        );
        return res.data;
      } catch (error: any) {
        throw new Error(error.response?.data?.message || "Failed to request payout");
      }
    },
    mutationKey: [tqMutationKeys.organizer.requestPayout],
    retry: false,
    onError(error: Error) {
      console.error("Error requesting payout:", error);
    },
    onSuccess(data: RequestPayoutResponse) {
      console.log("Payout request successful:", data);
    },
  });
}
